import { saveTrackingDeviceInfo } from '@/model/tracking';
import DeviceDetection from '@/ports-frontend/DeviceDetection';
import DeviceOrientation from '@/ports-frontend/DeviceOrientation';
import FullScreenFrontend from '@/ports-frontend/FullScreen';

export const fetchDeviceInfo = async () => {
  const deviceInfo = await DeviceDetection.getDeviceInfo();
  const currentScreenSize = await DeviceOrientation.getScreenSize();
  const isFullScreen = await FullScreenFrontend.isFullScreen();

  saveTrackingDeviceInfo(deviceInfo);
  return {
    deviceInfo,
    currentScreenSize,
    isFullScreen,
  };
};
